"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeEventHierarchy = subscribeEventHierarchy;
function subscribeEventHierarchy(params) {
    const correlationData = this.addToCorrelation(params);
    const request = { 0: correlationData.correlationDataId };
    if (params.eventClassifierId !== undefined) {
        request[2] = params.eventClassifierId;
    }
    request[3] = params.wantDirectDescendantsOnly;
    request[4] = params.wantSelectionInformation;
    request[5] = params.fetchOnly;
    if (params.eventTaggedValueTopicNames !== undefined) {
        request[9] = params.eventTaggedValueTopicNames;
    }
    if (params.marketTaggedValueTopicNames !== undefined) {
        request[10] = params.marketTaggedValueTopicNames;
    }
    request[11] = params.excludeMarketInformation;
    request[12] = params.wantTabInformation;
    request[14] =
        params.wantSelectionBlurb !== undefined ? params.wantSelectionBlurb : false;
    this._sendStreamingMessage(12, request);
    return correlationData.promise;
}
